import { createAction, props } from '@ngrx/store';

/**
 * Sets the text in quick search for the componentId
 *  set on the app-response-search componentId input
 */
export const SET_TAG_SEARCH_TEXT = createAction(
  '[RESPONSE_SEACH_COMPONENT] SET_SEARCH_TEXT',
  props<{componentId: string; text: string}>()
);

export const CLEAR_ALL_TAG_SEARCH_TEXTS = createAction(
  '[RESPONSE_SEACH_COMPONENT] CLEAR_ALL_TAG_SEARCH_TEXTS'
);
